/**
 * Cart Drawer Fix for Intimelly
 * 
 * Fixes: Cart drawer not opening after add-to-cart on product pages.
 * Root cause: The theme's CartDrawer.#o() method dispatches cart:drawer:render
 * but this.open() is not called reliably. This fix listens for the render event
 * and opens the drawer after the cart content has been updated.
 * 
 * Also fixes: Cart count not updating when cart is cleared or modified externally.
 */
(function () {
  'use strict';

  var shouldOpenDrawer = false;

  // Track when cart:update comes from the product form (ATC click)
  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.source === 'product-form-component') {
      shouldOpenDrawer = true;
    }
  }, true);

  // Open the drawer after cart:drawer:render fires (content is now updated)
  document.addEventListener('cart:drawer:render', function () {
    if (shouldOpenDrawer) {
      shouldOpenDrawer = false;
      var drawer = document.querySelector('hdt-cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        try {
          drawer.open();
        } catch (err) {
          console.error('[cart-drawer-fix] Failed to open drawer:', err);
        }
      }
    }
  }, true);

  // Also ensure cart count updates when cart is cleared or modified via /cart/clear.js or /cart/update.js
  // by polling cart.js after any cart:reload event
  document.addEventListener('cart:reload', function () {
    fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Dispatch a cart count update so all hdt-cart-count elements update
        document.dispatchEvent(new CustomEvent('cart:count:update', {
          detail: {
            item_count: cart.item_count,
            total_price: cart.total_price
          }
        }));
      })
      .catch(function (err) {
        console.error('[cart-drawer-fix] Failed to fetch cart on reload:', err);
      });
  }, true);
})();
